module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "display": "none",
      "background": "#FFFFFF"
    },
    attrs: {
      "id": "save-programme"
    }
  }, [_c('br'), _vm._v(" "), _c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-body"
  }, [(_vm.$route.name === 'edit' || _vm.titleTemplate.title) ? _c('label', {
    staticStyle: {
      "display": "block",
      "font-size": "18px",
      "text-align": "left"
    },
    attrs: {
      "id": "txt-modal-edit"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('labels.edit_template_name')) + "\n      ")]) : _c('label', {
    staticStyle: {
      "display": "block",
      "font-size": "18px",
      "text-align": "left"
    },
    attrs: {
      "id": "txt-modal"
    }
  }, [_vm._v(_vm._s(_vm.$t('labels.add_template_name')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!(_vm.$route.name === 'edit' || _vm.titleTemplate.title)),
      expression: "!($route.name === 'edit' || titleTemplate.title)"
    }],
    staticClass: "form-control",
    staticStyle: {
      "padding-left": "15px",
      "height": "45px",
      "font-size": "18px",
      "border-radius": "0"
    },
    attrs: {
      "id": "title-template",
      "type": "text",
      "placeholder": _vm.$t('placeholder.template_title'),
      "name": "fname"
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$route.name === 'edit' || _vm.titleTemplate.title),
      expression: "$route.name === 'edit' || titleTemplate.title"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.title),
      expression: "title"
    }],
    staticClass: "form-control",
    staticStyle: {
      "padding-left": "15px",
      "height": "45px",
      "font-size": "18px",
      "border-radius": "0"
    },
    attrs: {
      "id": "edit-title-template",
      "type": "text",
      "placeholder": _vm.$t('placeholder.template_title'),
      "name": "fname"
    },
    domProps: {
      "value": (_vm.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.title = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "button-saveTemp",
    attrs: {
      "id": "success"
    }
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin",
    staticStyle: {
      "margin-right": "10px",
      "display": "none"
    },
    attrs: {
      "id": "loadButton"
    }
  }), _vm._v(_vm._s(_vm.$t('button.confirm')) + "\n      ")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-546d8e50","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Modal/SaveTemplate.vue
// module id = 835
// module chunks = 1 3